import { LC_API_KEY, LC_API_URL } from "../data/constants";

const API_URL = process.env.NODE_ENV === "development" ? "" : LC_API_URL;

// const API_URL =
//   process.env.NODE_ENV === "development"
//     ? ""
//     : process.env.REACT_APP_LC_API || "";

/**
 * Sends a report to the API endpoint
 * @param {Object} data - The report data to be sent
 * @returns {Promise} - Promise that resolves to the API response
 */
const sendReport = async (data) => {
  try {
    const body = {
      body: data,
    };
    const response = await fetch(`${API_URL}/reports`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": LC_API_KEY,
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`API Error (${response.status}): ${errorText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error sending report:", error);
    throw error;
  }
};

export { sendReport };
